import LocalEvaluateRequest from "../../../../../mode/local/LocalEvaluateRequest"
import { HackleUser, InAppMessageConfig } from "../../../../../../model/model"
import WorkspaceConfig from "../../../../../../workspace/config/WorkspaceConfig"
import { InAppMessageEvaluateScope } from "../../../InAppMessageEvaluateScope"
import { InAppMessageLayoutEvaluateRequest } from "../../InAppMessageLayoutEvaluateRequest"
import { InAppMessageEligibilityLocalEvaluateRequest } from "../../../eligibility/mode/local/InAppMessageEligibilityLocalEvaluateRequest"

export class InAppMessageLayoutLocalEvaluateRequest implements LocalEvaluateRequest, InAppMessageLayoutEvaluateRequest {
  readonly record = true

  constructor(
    readonly workspace: WorkspaceConfig,
    readonly user: HackleUser,
    readonly entity: InAppMessageConfig,
    readonly scope: InAppMessageEvaluateScope
  ) {}

  get inAppMessage(): InAppMessageConfig {
    return this.entity
  }

  static of(request: InAppMessageEligibilityLocalEvaluateRequest): InAppMessageLayoutLocalEvaluateRequest {
    return new InAppMessageLayoutLocalEvaluateRequest(request.workspace, request.user, request.entity, request.scope)
  }

  toString(): string {
    return `InAppMessageLayoutLocalEvaluateRequest(key=${this.entity.key})`
  }
}
